import { WishlistSchema } from "@apps/wishlist/schemas/WishlistSchema";
import { object } from "superstruct";

export const DeleteWishlistResponseSchema = object({
    deletedWishlist: WishlistSchema,
});
